import React, { useEffect, useMemo } from "react";
import { Tabs, message, Button } from "antd";
import Once from "../../components/Auth/Once/Once";
import { esiaLogin, getUserTokens } from "../../store/actions/userAction";
import LineLoader from "../../components/LineLoader/LineLoader";
import AuthorizedModal from "../../components/AuthorizedModal/AuthorizedModal";
import { Errors } from "../../store/slices/userSlice";
import Anytime from "../../components/Auth/Anytime/AnyTime";
import { useAppDispatch, useAppSelector } from "../../store";
import styles from "./Auth.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { LogWithEsia } from "../../components/Auth/LogWithEsia/LogWithEsia";
import LogWithPlatform from "../../components/Auth/LogWithPlatform/LogWithPlatform";

const Auth = () => {
  const { _IsLoading, _isModal, _token } = useAppSelector(
    ({ userSlice }) => userSlice
  );
  const { TabPane } = Tabs;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const code = searchParams.get("code");
  const state = searchParams.get("state");

  useEffect(() => {
    dispatch(getUserTokens());

    message.config({
      top: 85,
    });
  }, []);

  useEffect(() => {
    if (!_token && code && state) {
      dispatch(esiaLogin({ code, state }));
    }
  }, [_token, code, state, dispatch]);

  const handleChangeTab = () => {
    dispatch(Errors([""]));
  };

  const adaptiveSize = useMemo(() => {
    if (window.innerWidth < 500) {
      return "small";
    } else {
      return "large";
    }
  }, [window.innerWidth]);

  return (
    <>
      {_IsLoading ? (
        <LineLoader />
      ) : (
        <div className={styles.auth}>
          <h1 className={styles.authTitle}>Вход в профиль</h1>
          <Tabs centered size={adaptiveSize} onChange={handleChangeTab}>
            <TabPane tab="По паролю" key="1">
              <Anytime />
            </TabPane>
            <TabPane tab="По коду" key="2">
              <Once />
            </TabPane>
          </Tabs>

          <div className={styles.lineOr}>
            <span className={styles.lineOr__line} />
            <span className={styles.lineOr__Text}>или войдите через</span>
            <span className={styles.lineOr__line} />
          </div>

          <div className={styles.signinBy}>
            <LogWithEsia />
            <div className={styles.separator} />
            <LogWithPlatform />
          </div>

          <Button
            className={styles.registrationBtn}
            onClick={() => navigate("/registration")}
          >
            Зарегистрироваться
          </Button>
        </div>
      )}
      {_isModal ? <AuthorizedModal /> : null}
    </>
  );
};

export default Auth;
